"use client";

import { ReactLenis, useLenis } from "lenis/react";
import { usePathname } from "next/navigation";
import { type ReactNode, useEffect } from "react";

// =============================================================================

/**
 * Lenis smooth scroll on the window. Lenis drives the native scroll position,
 * so motion's useScroll and position: sticky keep working as usual.
 */
export function SmoothScroll({ children }: { children: ReactNode }) {
  return (
    <ReactLenis
      root
      options={{
        lerp: 0.1,
        smoothWheel: true,
        anchors: { offset: -80 },
        stopInertiaOnNavigate: true,
        respectReducedMotion: true,
      }}
    >
      <ScrollToTopOnNavigation />
      {children}
    </ReactLenis>
  );
}

// =============================================================================

/**
 * Next.js scrolls to the top on navigation, but Lenis may still be gliding
 * towards an older target: snap it to the new position.
 */
function ScrollToTopOnNavigation() {
  const pathname = usePathname();
  const lenis = useLenis();

  useEffect(() => {
    if (!lenis || window.location.hash) return;
    lenis.scrollTo(0, { immediate: true, force: true });
  }, [pathname, lenis]);

  return null;
}

// =============================================================================
